<template>
  <div>
      <v-layout>
        <v-flex xs12>
          <v-card class="pa-3">
            <v-layout justify-center class="mt-2 pt-3">
              <p  class="primary--text">{{reservation.name}}</p>
            </v-layout>
            <v-layout  column class="ml-2 mr-2">
              <v-flex>
                <v-textarea
                  v-model="reservation.description"
                  prepend-icon="mdi-text"
                  rows="1"
                  auto-grow
                  label="自助预约活动描述"
                  readonly
                >
                </v-textarea>
              </v-flex>
            </v-layout>
            <!-- <div class="mt-3">
                 <span class="primary&#45;&#45;text ml-4 mt-5">函件预约规则管理</span>
             </div>-->
            <v-divider></v-divider>
            <v-form ref="registerForm" class="pa-2" v-if="useFlag===true">
              <v-layout column>
                <v-flex>
                  <l-plate-picker
                    v-model="registerForm.plate"
                    label="车辆号牌*"
                    :disabled="disabledFlag===true"
                    :rules="[$rules.requiredS()]"></l-plate-picker>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="registerForm.ownerTel"
                    label="手机号码*"
                    :disabled="disabledFlag===true"
                    prepend-icon="mdi-phone"
                    :rules="$rules.phone11()"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field
                    prepend-icon="mdi-account"
                    v-model="registerForm.ownerName"
                    :label="'车主姓名'"
                    :disabled="disabledFlag===true"
                    ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field
                    :label="'车主单位'"
                    prepend-icon="mdi-account-group"
                    v-model="registerForm.ownerOrg"
                    :disabled="disabledFlag===true"
                   ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout column>
                <v-flex >
                  <v-select
                    :label="'证件类型'"
                    v-model="registerForm.ownerIDType"
                    :items="registerForm.typeSelect"
                    :disabled="disabledFlag===true"
                    item-text="text"
                    item-value="value"
                    prepend-icon="mdi-account-box"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="'证件号码'"
                    v-model="registerForm.ownerIDNumber"
                    :disabled="disabledFlag===true"
                    prepend-icon="mdi-account-card-details"
                    ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
            <v-layout justify-center>
              <v-btn class="primary" :loading="loading" @click="submitForm()" :disabled="disabledFlag===true">提交</v-btn>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>
<script>
import LPlatePicker from '../../../components/LPlatePicker'
import {VIOLATION_ROLE} from '../../../object'
import {ReservationGroup, ReservationAuthority, Reservation} from '../../../object'
function LoginInfo ({token, name, id}) {
  this.token = token || ''
  this.name = name || ''
  this.id = id || ''
  // this.permission = permission || {}
}
function VisitorVehicle (id = 0, p = '', t = '', n = '', o = '', idt = '', idn = '') {
  return {
    id: id,
    plate: p,
    ownerTel: t,
    ownerName: n,
    ownerOrg: o,
    ownerIDNumber: idn,
    ownerIDType: idt,
  }
}
export default{
  components: {
    LPlatePicker,
  },
  data () {
    return {
      reservation: new ReservationGroup(),
      interviewee: '',
      showControllers: false,
      registerForm: {
        ownerName: '',
        ownerIDType: '',
        ownerIDNumber: '',
        plate: '',
        ownerTel: '',
        ownerOrg: '',
        typeSelect: [
          {
            text: '居民身份证',
            value: 'idCard'
          },
          {
            text: '军官证|警官证|士兵证',
            value: 'osCard'
          },
          {
            text: '护照',
            value: 'passport'
          },
          {
            text: '港澳|台湾居民来往内地通行证',
            value: 'mtPermit'
          }
        ]
      },
      loading: false,
      disabledFlag: false,
      useFlag: true,
      unUseReason: '',
      unUseReasonTitle: '',
      submitDisabled: true
    }
  },
  methods: {
    getUserInfo () {
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    },
    async getReservationInfo () {
      let {items} = await this.$store.dispatch('reservation/getReservationGroups', {
        pagination: {},
        search: {key: 'id', value: this.$route.query.obgrpId},
      })
      if (items.length) {
        let item = items[0]
        item.editInfo = false
        item.loading = false
        this.reservation.name = item.obgrp.name
        this.reservation.description = item.obgrp.description
        this.reservation.id = item.obgrp.id
        this.reservation.owner = {loginId: this.getUserInfo().id}
        this.reservation.applicant = {loginId: this.getUserInfo().id}
      }
      else {
        this.$L.alert('error', '未找到该预约分组')
      }
    },
    addVehicle () {
      if (this.$refs.registerForm.validate()) {
        // console.log('valid', this.addVehicleForm)
        let f = this.registerForm
        // this.$nextTick(() => {
        this.reservation.vehicles.push(new VisitorVehicle(
          this.reservation.vehicles.length,
          f.plate,
          f.ownerTel,
          f.ownerName,
          f.ownerOrg,
          f.ownerIDType,
          f.ownerIDNumber,
        ))
        return true
      }
      else {
        this.$L.alert('error', {message: '表单数据不合法'})
        return false
      }
    },
    async submitForm () {
      if (!this.addVehicle()) {
        return
      }
      this.loading = true
      let res = await this.$store.dispatch('reservation/submitReservation', {
        reservationGroup: this.reservation,
        type: 'admin',
      })
      this.loading = false
      this.$L.alert('success', {message: '预约成功'})
      this.disabledFlag = true
    },
  },
  created () {
    this.getReservationInfo()
  },
  mounted () {
    this.$refs.registerForm.validate()
  },

}
</script>
<style>

</style>
